<script>
	import { getSuitColor } from '../helpers';
	import "../shared.css";

	export let label;
	export let suit;

	$: suitColor = getSuitColor(suit);
	$: titleColor = suit === 'captain' ? 'black' : 'white';
	$: border = suit === 'captain' ? '1px solid gray' : 'none';
</script>

<div class="card-title" style="--sc:{suitColor}; --tc:{titleColor}; --b:{border}">
	{#if suit !== 'status'}
		<slot name="icon" />
	{/if}
	<div class="font-heading">{label.toUpperCase()}</div>
</div>

<style lang="scss">
	.card-title {
		color: var(--tc);
		font-size: calc(var(--height) / 25.0625); //16px;
		font-weight: 300;
		line-height: 1.1;
		background-color: var(--sc);
		padding: calc(var(--height) / 401) calc(var(--height) / 36.455) calc(var(--height) / 200.5) calc(var(--height) / 28.643); //1px 11px 2px 14px;
		border-radius: 0 calc(var(--height) / 20.05) calc(var(--height) / 20.05) 0;//0 20px 20px 0;
		box-sizing: border-box;
		-webkit-box-sizing: border-box;
		border: var(--b);
		width: fit-content;
		align-items: center;
		gap: calc(var(--height) / 100.25); //4px;
		text-overflow: clip;
		& :global(img) {
			color: inherit;
			height: 1em;
			filter: brightness(0) invert(1);
		}
	}
</style>
